import React, { useState } from "react";
import { UiButton } from "@ui-monorepo/index";
import { useTranslation } from "react-i18next";
import styles from "./gift-card.module.css";

export const GiftCard = ({ url }: {url: string;}) => {
  const [closeGift, setCloseGift] = useState(false);
  const { t } = useTranslation();
  const handleButtonClick = () => {
    window.open(url, "_blank");
  };
  return (
    <div
      role={"gift-card-container"}
      className={`${styles.giftCard} ${closeGift ? styles.closeGift : ""}`}>

      <div className={styles.boxClose} onClick={() => setCloseGift(true)}>
        <span className='icon-close'></span>
      </div>
      <img src='/prod/assets/web/catalogue/icons/gift.png' alt='Gift Card' />
      <div className={styles.content}>
        <p>{t("fakeDoor.giftCard.description")}</p>
        <UiButton
          onClick={handleButtonClick}
          styles={{
            background: "#0C1220",
            color: "#ffffff"
          }}>

          {t("fakeDoor.giftCard.button")}
        </UiButton>
      </div>
    </div>);

};